import { Component, Input, Output, EventEmitter } from "@angular/core";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
import { BaseComponent } from "../base.component";
import {
  Form,
  FormControl,
  FormGroup,
  FormArray,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import { PhoneValidator } from "../_directives/index";
import * as _ from "lodash";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { customEmailFormValidator } from "../_helpers/customEmailFormValidator";

@Component({
  moduleId: module.id,
  selector: "editparent",
  templateUrl: "editparent.component.html",
})
export class EditParentComponent extends BaseComponent {
  @Input() registeredUser: any;
  @Output() onComplete?: EventEmitter<void> = new EventEmitter();
  model: any = {};
  loading: boolean = false;
  errorMessage: string;
  successMessage: string;

  formGroupObj: FormGroup;
  addedChildren: any[] = [];
  removedChildren: any[] = [];

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  run() {
    this.formGroupObj = new FormGroup({
      firstName: new FormControl(
        this.registeredUser ? this.registeredUser.firstName : null,
        Validators.required
      ),
      lastName: new FormControl(
        this.registeredUser ? this.registeredUser.lastName : null,
        Validators.required
      ),
      email: new FormControl(
        this.registeredUser ? this.registeredUser.email : null,
        [Validators.required, Validators.email, customEmailFormValidator()]
      ),
      address: new FormControl(
        this.registeredUser ? this.registeredUser.address : null,
        [Validators.required]
      ),
      city: new FormControl(
        this.registeredUser ? this.registeredUser.city : null,
        [Validators.required]
      ),
      phone: new FormControl(
        this.registeredUser ? this.registeredUser.phone : null,
        [Validators.required, this.validatePhone]
      ),
      phone2: new FormControl(
        this.registeredUser ? this.registeredUser.phone2 : null,
        this.validatePhone
      ),
    });
  }

  validatePhone(c: FormControl) {
    let PHONE_REGEXP =
      /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    return !c.value || PHONE_REGEXP.test(c.value)
      ? null
      : {
          validatePhone: {
            valid: false,
          },
        };
  }

  onChildSelect(child) {
    this.registeredUser.children =
      this.registeredUser.children &&
      this.registeredUser.children.length &&
      this.registeredUser.children.length > 0
        ? this.registeredUser.children
        : [];
    let alreadyAddedChildren = _.filter(this.registeredUser.children, {
      id: child.id,
    });

    if (
      !alreadyAddedChildren ||
      !alreadyAddedChildren.length ||
      alreadyAddedChildren.length == 0
    ) {
      this.registeredUser.children.push(child);
      this.addedChildren.push(child);
    }
  }

  removeChildFromParent(child) {
    if (
      child &&
      child.id &&
      this.registeredUser &&
      this.registeredUser.children &&
      this.registeredUser.children.length
    ) {
      let removedChildren = _.remove(this.registeredUser.children, {
        id: child.id,
      });

      let amongAddedChildrenArr = _.filter(this.addedChildren, {
        id: child.id,
      });
      if (
        !amongAddedChildrenArr ||
        !amongAddedChildrenArr.length ||
        amongAddedChildrenArr.length == 0
      ) {
        this.removedChildren.push(child);
      } else {
        _.remove(this.addedChildren, { id: child.id });
      }
    }
  }

  submit() {
    if (!this.loading) {
      this.errorMessage = undefined;
      let postData = this.formGroupObj.getRawValue();
      postData.id = this.registeredUser.id;
      if (
        this.addedChildren &&
        this.addedChildren.length &&
        this.addedChildren.length > 0
      )
        postData["addedChildren"] = this.addedChildren;
      if (
        this.removedChildren &&
        this.removedChildren.length &&
        this.removedChildren.length > 0
      )
        postData["removedChildren"] = this.removedChildren;

      this.loading = true;
      this.addObservable(
        this.dataService.postEntity("save-parent", postData).subscribe(
          (data) => {
            this.loading = false;
            this.removedChildren = [];
            this.addedChildren = [];
            this.successMessage = "";
            this.alertService.success(this.base.messages["save_success"]);
            if (this.onComplete) {
              this.onComplete.emit();
            }
            let newRegUser = this.formGroupObj.getRawValue();
            newRegUser.id = this.registeredUser.id;
            newRegUser.children = this.registeredUser.children;
            this.dataService.registeredUser.next(newRegUser);
          },
          (error) => {
            this.loading = false;
            let body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.base.messages[body.statusText]
                  ? this.base.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
          }
        )
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/registereduser/editparent.component.ts